/**
 * Hard-coded site-wide announcement configuration.
 *
 * This is intentionally static (no admin UI). To change or retire the
 * announcement, edit the values below. Bumping `ANNOUNCEMENT_ID` re-shows the
 * bar to users who previously dismissed an older announcement.
 *
 * Flip `ANNOUNCEMENT_ENABLED` to show the site-wide announcement bar.
 * Educator-page printables live in `educator-printables.ts`.
 */

import { EDUCATOR_PRINTABLES } from "@/lib/constants/educator-printables";

/** Show the site-wide announcement bar. */
export const ANNOUNCEMENT_ENABLED = true;

/** Stable identifier used as the dismissal key in localStorage. */
export const ANNOUNCEMENT_ID = "choice-board-2026-9";

/** Short message shown in the announcement bar. */
export const ANNOUNCEMENT_MESSAGE = "Start the year with free classroom choice boards!";

/** Label for the bar's call-to-action that opens the printable PDF. */
export const ANNOUNCEMENT_CTA_LABEL = "Download PDF";

/** Announcement bar downloads the currently featured Educators printable. */
export const ANNOUNCEMENT_PDF_URL = EDUCATOR_PRINTABLES.choiceBoard.pdfUrl;

/** localStorage key for persisting dismissal across sessions. */
export const ANNOUNCEMENT_DISMISS_STORAGE_KEY = `announcement-dismissed:${ANNOUNCEMENT_ID}`;
